// Tetromino shapes, colors, and Super Rotation System (SRS) wall kicks.

export const PIECES = ['I', 'J', 'L', 'O', 'S', 'T', 'Z'];

// Slightly spread across the pink -> violet brand range so pieces stay
// readable against each other while still feeling on-brand.
export const COLORS = {
  I: [0.98, 0.66, 0.85],
  J: [0.94, 0.28, 0.62],
  L: [0.72, 0.11, 0.38],
  O: [0.95, 0.68, 0.99],
  S: [0.86, 0.28, 0.95],
  T: [0.66, 0.34, 0.98],
  Z: [0.49, 0.24, 0.94],
};

// Base spawn orientation (rotation state 0) for each piece.
const BASE = {
  I: [
    [0, 0, 0, 0],
    [1, 1, 1, 1],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
  ],
  J: [
    [1, 0, 0],
    [1, 1, 1],
    [0, 0, 0],
  ],
  L: [
    [0, 0, 1],
    [1, 1, 1],
    [0, 0, 0],
  ],
  O: [
    [1, 1],
    [1, 1],
  ],
  S: [
    [0, 1, 1],
    [1, 1, 0],
    [0, 0, 0],
  ],
  T: [
    [0, 1, 0],
    [1, 1, 1],
    [0, 0, 0],
  ],
  Z: [
    [1, 1, 0],
    [0, 1, 1],
    [0, 0, 0],
  ],
};

const rotateCW = (m) => {
  const n = m.length;
  return Array.from({ length: n }, (_, y) =>
    Array.from({ length: n }, (_, x) => m[n - 1 - x][y]),
  );
};

const toCells = (m) => {
  const cells = [];
  m.forEach((row, y) => row.forEach((v, x) => v && cells.push({ x, y })));
  return cells;
};

// SHAPES[type] = array of four rotation states, each a list of {x, y} cells.
export const SHAPES = {};
PIECES.forEach((type) => {
  if (type === 'O') {
    SHAPES[type] = [toCells(BASE[type])];
    return;
  }
  const states = [];
  let m = BASE[type];
  for (let i = 0; i < 4; i += 1) {
    states.push(toCells(m));
    m = rotateCW(m);
  }
  SHAPES[type] = states;
});

// Spawn position for each piece (board coordinates, y grows downward). Every
// piece spawns fully inside the visible playfield rather than in a hidden row.
export const SPAWN = {
  I: { x: 3, y: 0 },
  J: { x: 3, y: 0 },
  L: { x: 3, y: 0 },
  O: { x: 4, y: 0 },
  S: { x: 3, y: 0 },
  T: { x: 3, y: 0 },
  Z: { x: 3, y: 0 },
};

// SRS kick tables. Offsets are expressed in the conventional y-up frame and
// converted to the board's y-down frame when applied.
export const KICKS_JLSTZ = {
  '01': [[0, 0], [-1, 0], [-1, 1], [0, -2], [-1, -2]],
  '10': [[0, 0], [1, 0], [1, -1], [0, 2], [1, 2]],
  '12': [[0, 0], [1, 0], [1, -1], [0, 2], [1, 2]],
  '21': [[0, 0], [-1, 0], [-1, 1], [0, -2], [-1, -2]],
  '23': [[0, 0], [1, 0], [1, 1], [0, -2], [1, -2]],
  '32': [[0, 0], [-1, 0], [-1, -1], [0, 2], [-1, 2]],
  '30': [[0, 0], [-1, 0], [-1, -1], [0, 2], [-1, 2]],
  '03': [[0, 0], [1, 0], [1, 1], [0, -2], [1, -2]],
};

export const KICKS_I = {
  '01': [[0, 0], [-2, 0], [1, 0], [-2, -1], [1, 2]],
  '10': [[0, 0], [2, 0], [-1, 0], [2, 1], [-1, -2]],
  '12': [[0, 0], [-1, 0], [2, 0], [-1, 2], [2, -1]],
  '21': [[0, 0], [1, 0], [-2, 0], [1, -2], [-2, 1]],
  '23': [[0, 0], [2, 0], [-1, 0], [2, 1], [-1, -2]],
  '32': [[0, 0], [-2, 0], [1, 0], [-2, -1], [1, 2]],
  '30': [[0, 0], [1, 0], [-2, 0], [1, -2], [-2, 1]],
  '03': [[0, 0], [-1, 0], [2, 0], [-1, 2], [2, -1]],
};

export const kicksFor = (type, from, to) =>
  (type === 'I' ? KICKS_I : KICKS_JLSTZ)[`${from}${to}`];
